import { AuthService } from '@/core/core.barrel';
import { DataService } from '@/core/services/data.service';
import { StopShadowingStaff } from '@/core/store/auth';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';

@Component({
    selector: 'app-accessdenied',
    template: `
    <fullscreen-shell>
      <ng-template>
        <h1 class="tw-font-bold tw-text-6xl tw-p-8">{{h1}}</h1>
        <h2 class="tw-font-bold tw-text-3xl tw-pb-8">{{h2}}</h2>
        <p-button *ngIf="shadowedUserId != null" class="tw-rounded tw-text-white" label="Stop Shadowing" (click)="stopShadowingStaff()"></p-button>
        <p>Go to <a [routerLink]="['/']">Home Screen</a> page?</p>
      </ng-template>
    </fullscreen-shell>
`,
    standalone: false
})
export class AppAccessdeniedComponent {
  h1 : string;
  h2 : string;
  shadowedUserId : number;

  constructor(
    private router: Router,
    private auth: AuthService,
    private dataService: DataService,
    private store: Store){
    let code  = '';
   
    this.auth.getShadowedUserId().subscribe((id) => {
      this.shadowedUserId = id;
    });

    const extras = router.getCurrentNavigation().extras;
    if (extras && extras.state && extras.state.data && extras.state.data.error) {
      code = extras.state.data.error.status;
    }

    this.h1 = 'Oops! Access Denied.';
    this.h2 = `Error ${code} - You do not have the necessary permissions. Please contact management.`;
  }

  stopShadowingStaff() {
    this.dataService.put(`/shadowstaff/stop/${this.shadowedUserId}`, null).subscribe(
      () => {
        this.auth.loginSilent().subscribe((_) => {
          this.store.dispatch(new StopShadowingStaff());          
          this.router.navigateByUrl('/').then(() => {
            window.location.reload();
          })
        });
      }
    )
  }
}
